'use client'
import { useCallback, useContext } from 'react'

import { ToastContext, defaultToastState } from '../providers/toast-providers'

import { TToastType } from '@/components/shared/toast'

const useToast = () => {
  const toast = useContext(ToastContext)

  const onClose = useCallback(() => {
    if (toast?.onClose) {
      toast.onClose()
    }
  }, [toast])

  const show = useCallback(
    ({
      autoclose = true,
      ...state
    }: {
      positionBottom?: boolean
      type: TToastType
      title: string
      description?: string
      traceId?: string
      disableClose?: boolean
      onClose?: () => void
      autoCloseDuration?: number
      autoclose?: boolean
      transformTitle?: boolean
    }) => {
      if (toast?.setState) {
        const { setState } = toast

        setState({ positionBottom: true, show: true, ...state })

        if (autoclose) {
          setTimeout(
            () => {
              setState({ ...defaultToastState })
            },
            state?.autoCloseDuration ?? 5000,
          )
        }
      }
    },
    [toast],
  )

  return {
    show,
    close: onClose,
  }
}

export default useToast
